import { Injectable } from '@angular/core';

@Injectable()
export class MessageService {
  message: string = '';
  infoMessage: string = '';

  show(message: string) {
    this.message = message;
  }

  showAndHideAfterDelay(message: string, delay: number) {
    this.message = message;

    this.hide(delay);
  }

  hide(optionalDelay?: number) {
    setTimeout(() => {
      this.message = '';
      this.infoMessage = '';
    }, optionalDelay);
  }

  showInfo(message: string, delay?: number) {
    this.infoMessage = message;

    if (delay) {
      this.hide(delay);
    }
  }

  hideInfo() {
    this.infoMessage = '';
  }
}
